import { isOfType } from '../../../../ts-utils';
import { checkIfRevisionIsLocal } from './history-utils';
export const ADD_NEW_HISTORY_ITEM = 'ADD_NEW_HISTORY_ITEM';
export const FETCH_INITIAL_HISTORY_REQUEST = 'FETCH_INITIAL_HISTORY_REQUEST';
export const FETCH_INITIAL_HISTORY_FAILURE = 'FETCH_INITIAL_HISTORY_FAILURE';
export const FETCH_INITIAL_HISTORY_SUCCESS = 'FETCH_INITIAL_HISTORY_SUCCESS';
export const FETCH_NEXT_HISTORY_REQUEST = 'FETCH_NEXT_HISTORY_REQUEST';
export const FETCH_NEXT_HISTORY_FAILURE = 'FETCH_NEXT_HISTORY_FAILURE';
export const FETCH_NEXT_HISTORY_SUCCESS = 'FETCH_NEXT_HISTORY_SUCCESS';
export const addNewHistoryItem = (payload) => ({
    type: ADD_NEW_HISTORY_ITEM,
    payload,
});
export const fetchNextHistoryRequest = (payload) => ({
    type: FETCH_NEXT_HISTORY_REQUEST,
    payload,
});
export const fetchNextHistoryFailure = (payload) => ({
    type: FETCH_NEXT_HISTORY_FAILURE,
    payload,
});
export const fetchNextHistorySuccess = (payload) => ({
    type: FETCH_NEXT_HISTORY_SUCCESS,
    payload,
});
export const fetchInitialHistoryRequest = (payload) => ({
    type: FETCH_INITIAL_HISTORY_REQUEST,
    payload,
});
export const fetchInitialHistoryFailure = (payload) => ({
    type: FETCH_INITIAL_HISTORY_FAILURE,
    payload,
});
export const fetchInitialHistorySuccess = (payload) => ({
    type: FETCH_INITIAL_HISTORY_SUCCESS,
    payload,
});
export const fetchInitialHistory = ({ resourceId, commentId }) => async (dispatch, getState, { commentsService }) => {
    const commentState = getState().comments[resourceId];
    if (commentState?.type !== 'READY') {
        return;
    }
    const commentHistoryState = commentState.historyById[commentId];
    // If there are already history items in state and threre revision which are not locally created,
    // initial fetch is already done
    if (commentHistoryState?.items &&
        commentHistoryState.items.filter((i) => !checkIfRevisionIsLocal(i.revisionId)).length) {
        return;
    }
    dispatch(fetchInitialHistoryRequest({ resourceId, commentId }));
    const result = await commentsService.fetchCommentHistory({
        commentId,
        cursorPaging: { limit: 5 },
    });
    if (result.type === 'SUCCESS') {
        const { history, nextCursor } = result.response;
        dispatch(fetchInitialHistorySuccess({
            resourceId,
            commentId,
            nextCursor,
            history,
        }));
    }
    else {
        dispatch(fetchInitialHistoryFailure({ resourceId, commentId }));
    }
};
export const fetchNextHistory = ({ resourceId, commentId }) => async (dispatch, getState, { commentsService }) => {
    const commentState = getState().comments[resourceId];
    if (commentState?.type !== 'READY') {
        return;
    }
    const historyState = commentState.historyById[commentId];
    if (historyState === undefined || historyState.nextCursor === null) {
        return;
    }
    dispatch(fetchNextHistoryRequest({ resourceId, commentId }));
    const result = await commentsService.fetchCommentHistory({
        commentId,
        cursorPaging: { limit: 5, cursor: historyState.nextCursor },
    });
    if (result.type === 'SUCCESS') {
        const { history, nextCursor } = result.response;
        dispatch(fetchNextHistorySuccess({
            resourceId,
            commentId,
            nextCursor,
            history,
        }));
    }
    else {
        dispatch(fetchNextHistoryFailure({ resourceId, commentId }));
    }
};
export const isHistoryAction = isOfType([
    FETCH_INITIAL_HISTORY_REQUEST,
    FETCH_INITIAL_HISTORY_FAILURE,
    FETCH_INITIAL_HISTORY_SUCCESS,
    FETCH_NEXT_HISTORY_REQUEST,
    FETCH_NEXT_HISTORY_FAILURE,
    FETCH_NEXT_HISTORY_SUCCESS,
    ADD_NEW_HISTORY_ITEM,
]);
//# sourceMappingURL=history-actions.js.map